"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "consortium-page"
  }, [_c("h1", {
    staticClass: "consortium-page__title title-page"
  }, [_vm._v("Contratos")]), _vm._v(" "), _c("div", [_vm.contractsList.length ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("b-table", {
    ref: "multiSortTable",
    attrs: {
      data: _vm.contractsList,
      paginated: "",
      "backend-pagination": "",
      total: _vm.total,
      "per-page": _vm.perPage,
      "sort-icon": _vm.sortIcon,
      "sort-icon-size": _vm.sortIconSize,
      loading: _vm.isLoading,
      "pagination-rounded": true,
      "aria-next-label": "Próxima página",
      "aria-previous-label": "Página anterior",
      "aria-page-label": "Página",
      "aria-current-label": "Página atual",
      "row-class": function rowClass() {
        return "consortium-page__row";
      }
    },
    on: {
      "page-change": _vm.onPageChange
    }
  }, [[_c("b-table-column", {
    attrs: {
      label: "Código"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$plan$;
        return [_vm._v("\n                " + _vm._s(((_props$row$plan$ = props.row.plan[0]) === null || _props$row$plan$ === void 0 ? void 0 : _props$row$plan$.dadosConsorcio.codigoBem) || "--") + "\n              ")];
      }
    }], null, false, 1667269168)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Valor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$plan$2;
        return [_vm._v("\n              " + _vm._s(((_props$row$plan$2 = props.row.plan[0]) === null || _props$row$plan$2 === void 0 ? void 0 : _props$row$plan$2.dadosConsorcio.valorBem) || "--") + "\n            ")];
      }
    }], null, false, 3756991)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Grupo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$plan$3;
        return [_vm._v("\n              " + _vm._s(((_props$row$plan$3 = props.row.plan[0]) === null || _props$row$plan$3 === void 0 ? void 0 : _props$row$plan$3.dadosConsorcio.tipoGrupo) || "--") + "\n            ")];
      }
    }], null, false, 2694453166)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Completado"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(props.row.completed ? "Sim" : "Não") + "\n            ")];
      }
    }], null, false, 338019776)
  })]], 2)], 1)]) : _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-md-12 ml-auto col-xl-12 mr-auto"
  }, [_c("card", [_c("div", {
    staticClass: "content-list"
  }, [_c("h4", {
    staticClass: "text-not-found"
  }, [_vm._v("\n              Não temos contratos para este usuário.\n            ")])])])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;